import { render, staticRenderFns } from "./ImageZoomCarousel.vue?vue&type=template&id=175cf1e2&scoped=true"
import script from "./ImageZoomCarousel.vue?vue&type=script&lang=js"
export * from "./ImageZoomCarousel.vue?vue&type=script&lang=js"
import style0 from "./ImageZoomCarousel.vue?vue&type=style&index=0&id=175cf1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175cf1e2",
  null
  
)

export default component.exports